/**
 * Canonical URLs for the NexAgenda orb assets (idle + listening).
 * JPEGs over dark background are composited with `mix-blend-mode: screen`
 * so the black rectangle disappears and only the luminous orb shows.
 */
export const ORB_IDLE_URL =
  "https://static.prod-images.emergentagent.com/jobs/ac18c01a-6a7a-4ddd-a9f5-8c00766d380b/images/f91c3576812734cad3dd37e0219902b23393628223f3ba8179c4f86f4e3ae5cb.jpeg";

export const ORB_ACTIVE_URL =
  "https://static.prod-images.emergentagent.com/jobs/ac18c01a-6a7a-4ddd-a9f5-8c00766d380b/images/7bdb6f2543c083aea69fbf4da3840a244b39bbfb9540a6bf9b55e4904681ff31.jpeg";

let _preloaded = false;

/** Kick off browser-cache warm-up for both orb states once. No-op after first call. */
export function preloadOrb() {
  if (_preloaded || typeof window === "undefined") return;
  _preloaded = true;
  try {
    [ORB_IDLE_URL, ORB_ACTIVE_URL].forEach((url) => {
      const img = new Image();
      img.src = url;
    });
  } catch {
    /* ignore */
  }
}
